import { Box, Spinner } from "@chakra-ui/react";
import FaceliftText from "../FaceliftText";

export const FaceliftLoadingIndicator: React.FC = () => (
  <Box display="flex" flexDirection="column" alignItems="center" gap={4}>
    <Spinner size="xl" color="blue.500" borderWidth="4px" />
    <FaceliftText fontSize="md" color="gray.600">Loading...</FaceliftText>
  </Box>
);
